<template>
  <a
    class="work-header-search-field"
    @click="handleSearchBarClick"
  >
    <Searchbar
      :show-field="activeModule.isSearchable"
      :has-expert-search="activeModule.hasExpertSearch"
      :place-holder="searchbarPlaceholder"
    />
  </a>
</template>

<script>
import Searchbar from '../../../modules/search/components/SearchBar';
import searchService from '../../../modules/search/services/search-services';
import { mapState } from 'vuex';

export default {
  name: 'WorkHeaderSearchField',
  components: { Searchbar },
  computed: {
    ...mapState(['activeModule']),
    searchbarPlaceholder() {
      if (
        typeof this.activeModule.furtherInformations !== 'undefined' &&
        'label' in this.activeModule.furtherInformations
      )
        return this.activeModule.furtherInformations.label + ' suchen';
      else return this.$t('Components.sentences.searchGlobally');
    },
  },
  methods: {
    handleSearchBarClick() {
      if (this.activeModule.isSearchable === false) {
        this.goToSearch();
      }
    },
    goToSearch() {
      return searchService.routeToGlobalSearch();
    },
  },
};
</script>
